export const EVENT_START_DATE_COUNTDOWN_CUTOFF_INTERVAL_HOURS = 72;
